import { Controller, useForm } from "react-hook-form";
import useAxios from "../../../Utils/useAxios";
import { Button, Form } from "reactstrap";
import { FileInputField } from "../../../CommonElements";
import updateShiftPreview from "../services/updateShiftPreview";

const FormUploadTemplate = ({ toggle, setShift, setMode }) => {
  const axiosInstance = useAxios();

  const {
    control,
    handleSubmit,
  } = useForm({
    mode: "onChange",
  });

  const uploadBuktiTandaTerima = (formData) => {
    setShift((prev) => ({...prev, berkas: formData.pdf}))
    updateShiftPreview(axiosInstance, formData).then((res) => {
      setShift((prev) => ({...prev, data: res.data}))
      setMode('preview')
      toggle();
    });
  };

  return (
    <Form onSubmit={handleSubmit(uploadBuktiTandaTerima)}>
      <Controller
        name="excel"
        control={control}
        rules={{
          required: "Harap upload Excel yang sesuai",
        }}
        render={({ field, fieldState }) => (
          <FileInputField
            label={"Excel"}
            fieldState={fieldState}
            {...field}
            accept=".xlsx"
            isRequired
          />
        )}
      />
      <Controller
        name="pdf"
        control={control}
        rules={{
          required: "Harap upload PDF yang sesuai",
        }}
        render={({ field, fieldState }) => (
          <FileInputField
            label={"PDF"}
            fieldState={fieldState}
            {...field}
            accept=".pdf"
            isRequired
          />
        )}
      />
      <Button color="primary">Lihat Preview</Button>
    </Form>
  );
};

export default FormUploadTemplate;
